export default __webpack_public_path__ + "static/media/NYC_Travel_3_2.59857a64.png";